import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Table } from '@agconnections/grow-ui';
import FarmRow from 'screens/Property/PropertiesLanding/components/FarmRow';
import CropZoneRow from 'screens/Property/PropertiesLanding/components/CropZoneRow';
import FieldRow from 'screens/Property/PropertiesLanding/components/FieldRow';

const renderCropZoneRow = (property, field, cropZone, geoJSONMap, handlers) => {
  const cropZoneGeoJSON = geoJSONMap.get(cropZone.id);
  return (
    <Table.Row
      key={cropZone.id}
      onClick={() => handlers.handleSelectedCropZone(property, field, cropZone)}
      selectable={!!property.fields.length}
      selected={handlers.isCropZoneSelected(cropZone)}
    >
      <Table.Cell>
        <CropZoneRow
          cropZone={cropZone}
          icon={cropZoneGeoJSON}
          fieldId={field.id}
          isEditable={false}
        />
      </Table.Cell>
    </Table.Row>
  );
};

const renderCropZones = (field, property, geoJSONMap, handlers) => {
  return field.cropzones.map(cropZone =>
    renderCropZoneRow(property, field, cropZone, geoJSONMap, handlers)
  );
};

const renderFieldRowGroup = (field, property, geoJSONMap, handlers) => {
  const fieldGeoJSON = geoJSONMap.get(field.id);
  return (
    <Table.RowGroup
      key={field.id}
      arrowIcon
      canOpen={!!field.cropzones.length}
      onClick={() => handlers.handleSelectedField(property, field)}
      selectable={!!property.fields.length}
      selected={handlers.isFieldSelected(field)}
      indeterminate={handlers.isPropertyIndeterminate(field)}
    >
      <Table.Row>
        <Table.Cell>
          <FieldRow field={field} icon={fieldGeoJSON} />
        </Table.Cell>
      </Table.Row>
      {renderCropZones(field, property, geoJSONMap, handlers)}
    </Table.RowGroup>
  );
};

const renderFields = (property, geoJSONMap, handlers) =>
  property.fields.map(field =>
    renderFieldRowGroup(field, property, geoJSONMap, handlers)
  );

const GroupByFarm = ({
  property,
  geoJSONMap,
  handleSelectedFarm,
  isFarmSelected,
  handleSelectedField,
  isFieldSelected,
  handleSelectedCropZone,
  isCropZoneSelected,
  isPropertyIndeterminate
}) => {
  const handlers = {
    handleSelectedField,
    isFieldSelected,
    handleSelectedCropZone,
    isCropZoneSelected,
    isPropertyIndeterminate
  };
  return (
    <Table.RowGroup
      key={property.id}
      arrowIcon
      canOpen={!!property.fields.length}
      onClick={() => handleSelectedFarm(property)}
      selectable={!!property.fields.length}
      selected={isFarmSelected(property)}
      indeterminate={isPropertyIndeterminate(property)}
    >
      <Table.Row>
        <Table.Cell>
          <FarmRow farm={property} />
        </Table.Cell>
      </Table.Row>
      {renderFields(property, geoJSONMap, handlers)}
    </Table.RowGroup>
  );
};
GroupByFarm.propTypes = {
  property: PropTypes.shape({
    id: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        cropzones: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string.isRequired
          })
        ).isRequired
      })
    ).isRequired
  }).isRequired,
  geoJSONMap: PropTypes.instanceOf(Map).isRequired,
  handleSelectedFarm: PropTypes.func.isRequired,
  isFarmSelected: PropTypes.func.isRequired,
  handleSelectedField: PropTypes.func.isRequired,
  isFieldSelected: PropTypes.func.isRequired,
  handleSelectedCropZone: PropTypes.func.isRequired,
  isCropZoneSelected: PropTypes.func.isRequired,
  isPropertyIndeterminate: PropTypes.func.isRequired
};
export default memo(GroupByFarm);
